import { render, staticRenderFns } from "./PopAddBase.vue?vue&type=template&id=18a320eb&scoped=true&"
import script from "./PopAddBase.vue?vue&type=script&lang=js&"
export * from "./PopAddBase.vue?vue&type=script&lang=js&"
import style0 from "./PopAddBase.vue?vue&type=style&index=0&id=18a320eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a320eb",
  null
  
)

export default component.exports